import React, { useState, useEffect } from 'react';
import { api } from '../api/client';

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export default function OpeningHoursEditor() {
  const [hours, setHours] = useState([]);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.get('/opening-hours').then(data => {
      // Ensure all 7 days exist
      const fullWeek = Array.from({ length: 7 }, (_, i) => {
        const existing = data.find(h => h.day_of_week === i);
        return existing || { day_of_week: i, is_open: false, open_time: null, close_time: null };
      });
      setHours(fullWeek);
    }).catch(() => {});
  }, []);

  const updateDay = (dayOfWeek, field, value) => {
    setHours(prev => prev.map(h =>
      h.day_of_week === dayOfWeek ? { ...h, [field]: value } : h
    ));
  };

  const saveAll = async () => {
    setSaving(true);
    setMessage('');
    try {
      for (const day of hours) {
        await api.post('/admin/opening-hours/update', {
          dayOfWeek: day.day_of_week,
          isOpen: day.is_open,
          openTime: day.open_time?.substring(0, 5) || '10:00',
          closeTime: day.close_time?.substring(0, 5) || '18:00',
        });
      }
      setMessage('All hours saved');
      setTimeout(() => setMessage(''), 2000);
    } catch (err) {
      setMessage(`Error: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  if (hours.length === 0) return null;

  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>Club Hours</h3>
      {message && (
        <div style={{ fontSize: 13, color: 'var(--success)', marginBottom: 8 }}>{message}</div>
      )}
      <div style={{ display: 'grid', gap: 8 }}>
        {hours.map(h => (
          <div key={h.day_of_week} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            padding: '8px 0', borderBottom: '1px solid var(--border)',
            flexWrap: 'wrap'
          }}>
            <span style={{ width: 90, fontWeight: 500, fontSize: 14 }}>
              {DAY_NAMES[h.day_of_week]}
            </span>
            <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={h.is_open}
                onChange={e => updateDay(h.day_of_week, 'is_open', e.target.checked)}
                style={{ width: 'auto' }}
              />
              Open
            </label>
            {h.is_open && (
              <>
                <input
                  type="time"
                  value={h.open_time?.substring(0, 5) || '10:00'}
                  onChange={e => updateDay(h.day_of_week, 'open_time', e.target.value)}
                  style={{ width: 110, padding: '4px 8px', fontSize: 13 }}
                />
                <span style={{ color: 'var(--text-muted)' }}>-</span>
                <input
                  type="time"
                  value={h.close_time?.substring(0, 5) || '18:00'}
                  onChange={e => updateDay(h.day_of_week, 'close_time', e.target.value)}
                  style={{ width: 110, padding: '4px 8px', fontSize: 13 }}
                />
              </>
            )}
          </div>
        ))}
      </div>
      <button
        className="btn-primary"
        onClick={saveAll}
        disabled={saving}
        style={{ marginTop: 12, width: '100%' }}
      >
        {saving ? 'Saving...' : 'Save Hours'}
      </button>
    </div>
  );
}
